module.exports = __webpack_public_path__ + "img/DO.109acb61.svg";